import { useState } from "react";
import { PincodeInput } from "./PincodeInput";
import { DeliveryInfo } from "./DeliveryInfo";
import { DefaultServices } from "./DefaultServices";
import { getDeliveryEstimate } from "@nusrif/services";
import { useConfig } from "@nusrif/contexts";
import { DeliveryEstimate } from "@nusrif/types";

export const DeliveryServices = () => {
  const config = useConfig();
  const [deliveryInfo, setDeliveryInfo] = useState<DeliveryEstimate | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [checkedPincode, setCheckedPincode] = useState<string>("");

  const handlePincodeCheck = async (pincode: string) => {
    setIsLoading(true);
    try {
      const res = await getDeliveryEstimate(pincode);
      if (res.success) {
        setDeliveryInfo({
          standard: res.data.etd, // Use ETD for standard delivery
          express: "", // No express from API, leave blank or handle as needed
          cod: config.cod === 'true',
          returnPolicy: `${config.returnPeriodDays} days return policy`,
          estimated_days: res.data.estimated_days
        });
        setCheckedPincode(pincode);
      } else {
        setDeliveryInfo(null);
      }
    } catch (error) {
      setDeliveryInfo(null);
      console.error("Error checking delivery:", error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="space-y-4">
      <h3 className="text-lg font-semibold text-black">Delivery & Services</h3>
      <PincodeInput onCheck={handlePincodeCheck} isLoading={isLoading} />
      {deliveryInfo ? (
        <DeliveryInfo deliveryInfo={deliveryInfo} pincode={checkedPincode} />
      ) : (
        <DefaultServices config={config} />
      )}
    </div>
  );
};